<template>
  <transition name="fade" appear>
    <div class="app-container" :style="{ width: '100vw' }">
      <sidebar
        :menu-items="sidebarMenuItems"
        v-if="$route.path !== '/promptmultifactor' && loggedIn"
      >
      </sidebar>

      <div>
        <!-- condensed sidebar for the sign in experience -->
        <DesktopSideBar v-if="!loggedIn" :menu-items="[]" />
      </div>

      <AppContent>
        <top-nav
          v-if="loggedIn && $route.path !== '/promptmultifactor'"
          :sidebar-items="sidebarMenuItems"
        />

        <Page>
          <transition class="flex-grow-2" name="fade" mode="out-in" appear>
            <router-view />
          </transition>
        </Page>
      </AppContent>
    </div>
  </transition>
</template>

<script>
import { mapGetters, mapState } from 'vuex'
import Page from '@/containers/Page'
import AppContent from '@/containers/AppContent'
import Sidebar from '@/components/Sidebar'
import TopNav from '@/components/navs/Top/index'
import DesktopSideBar from '@/components/Sidebar/components/Desktop'
import { windowStore } from '@/utilities/window/store'
import { sidebarMenuItems } from '@/utilities/sidebarMenuItems/Homeowner'
import { hoaUtility } from '@/services/Hoa/store'

export default {
  components: {
    DesktopSideBar,
    TopNav,
    Sidebar,
    Page,
    AppContent
  },

  data: function() {
    return {
      myEnhancedFeatures: []
    }
  },

  watch: {
    //This is necessary because the sidebar needs reloaded when the single load features are populated
    myEnhancedFeatures() {
      if (this.myEnhancedFeatures && this.myEnhancedFeatures.length > 0) {
        this.sidebarMenuItems
      }
    }
  },

  methods: {
    /**
     * Status of item, alter animation name based on action.
     */
    async retrieveFeatureList() {
      console.debug('in retrieveFeatureList()...')
      await hoaUtility
        .dispatch('getEnabledFeaturesList', {
          hoaID: this.hoaId
        })
        .then(({ list }) => {
          if (list && list.length > 0) {
            console.debug(
              'getEnabledFeaturesList========AppHomeowner=========================' +
                JSON.stringify(list)
            )

            this.myEnhancedFeatures = list
          }
        })

      return []
    }
  },

  computed: {
    ...mapGetters('user', ['loggedIn', 'currentHoaId']),
    ...mapState({
      hoaId: state => state.user.selectedHoaId
    }),
    sidebarMenuItems() {
      return sidebarMenuItems({
        hoaId: this.currentHoaId,
        enhancedFeatures: this.myEnhancedFeatures
      })
    }
  },

  async mounted() {
    if (
      this.myEnhancedFeatures &&
      this.myEnhancedFeatures.length == 0 &&
      this.hoaId !== undefined &&
      this.hoaId
    ) {
      console.debug('in mounted...')
      await this.retrieveFeatureList()
    }
  },

  beforeCreate() {
    this.$store.dispatch('user/setUnitFromCookie')

    windowStore.dispatch('init')
  }
}
</script>
